import React from 'react';
import { Comment } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import localization from '../../../../localization';
import { AnswerCommentHeader, answerTypes } from '../components';
import AnswerView from './AnswerView';
import { FlashIndicator } from '../.././../../components';
import Comments from './Comments';
import './style.scss';

const {
    topic: strings,
} = localization;

const Answer = ({
    answer: answerProp = {},
    lastUpdatedCommentId,
    clearUpdatedComment,
    ...props
}) => {
    const {
        id,
        comments,
        createdAt,
        updatedAt,
        createdByUser: {
            firstName,
            lastName,
            specialty,
        } = {},
        deletedAt,
        ownAnswer,
    } = answerProp;
    const answer = answerProp;
    let content;
    const specialtyName = (specialty && specialty.name) || undefined;
    if (deletedAt) {
        const deleteMsg = ownAnswer ? strings.deletedAnswerOwn : strings.deletedAnswer;
        content = <Comment.Text className="deleted" >{deleteMsg}</Comment.Text>;
    } else {
        content = (<AnswerView
            specialty={specialtyName}
            {...props}
            {...answer}
        />);
    }

    const author = `${firstName} ${lastName}`;

    return (
        <Comment>
            <FlashIndicator
                active={id === lastUpdatedCommentId}
                makeInactive={clearUpdatedComment}
                activeClass="highlighted"
                inactiveClass="inactive"
            >
                <Comment.Content>
                    <AnswerCommentHeader
                        updatedAt={updatedAt}
                        createdAt={createdAt}
                        author={author}
                        type={answerTypes.answer}
                    />
                    <Comment.Text className="content-full">{content}</Comment.Text>
                </Comment.Content>
            </FlashIndicator>
            <Comments
                comments={comments}
                lastUpdatedCommentId={lastUpdatedCommentId}
            />
        </Comment>
    );
};

Answer.propTypes = {
    answer: PropTypes.shape({
        id: PropTypes.number.isRequired,
        topicId: PropTypes.number.isRequired,
        comments: PropTypes.arrayOf(PropTypes.shape()),
        createdAt: PropTypes.string.isRequired,
        updatedAt: PropTypes.string.isRequired,
        createdByUser: PropTypes.shape({
            firstName: PropTypes.string.isRequired,
            lastName: PropTypes.string.isRequired,
        }).isRequired,
        deletedAt: PropTypes.string,
        ownAnswer: PropTypes.bool.isRequired,
    }),
    comments: PropTypes.arrayOf(PropTypes.shape()),
    clearUpdatedComment: PropTypes.func.isRequired,
    // meta
    lastUpdatedCommentId: PropTypes.number,
};

Answer.defaultProps = {
    comments: [],
    lastUpdatedCommentId: null,
    answer: null,
};

export default Answer;
